// ======================================================================
// File Name       : LiveProgressDetailChart
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';

class LiveProgressDetailChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toShow: true,
    };
    this.createJoinMeetingChart = this.createJoinMeetingChart.bind(this);
    this.createChart = this.createChart.bind(this);
    this.drawChart = this.drawChart.bind(this);
  }

  drawChart() {
    const canvas = this.myCanvas;
    const ctx = canvas.getContext('2d');
    const yAxes = canvas.height;
    const ctxWidth = canvas.width;
    this.createJoinMeetingChart(ctx, ctxWidth, yAxes);
  }

  componentDidMount() {
    this.drawChart();
  }

  componentDidUpdate() {
    this.drawChart();
  }

  createJoinMeetingChart(ctx, ctxWidth, yAxes) {
    const { liveSecernId, arrayDataSetsForChart } = this.props;
    const widthOfPercent = ctxWidth / 100;
    if (arrayDataSetsForChart && arrayDataSetsForChart.length) {
      let sumPreXAxes = 0;
      for (let i = 0; i < arrayDataSetsForChart.length; i++) {
        let xAxes = widthOfPercent * arrayDataSetsForChart[i];
        let preXAxes = 0;
        if (i > 0) {
          preXAxes = sumPreXAxes;
          xAxes = preXAxes + xAxes;
        }
        sumPreXAxes = xAxes;
        if (i % 2 === 0) {
          const colorOfMiss = 'rgba(192, 192, 192, 1)';
          this.createChart(ctx, preXAxes, xAxes, yAxes, colorOfMiss);
        } else {
          const colorOfJoin = 'rgba(0, 128, 0, 1)';
          this.createChart(ctx, preXAxes, xAxes, yAxes, colorOfJoin);
        }
      }
    }
  }

  createChart(ctx, xAxes, xAxesToMove, yAxes, colorStyle) {
    ctx.beginPath();
    ctx.strokeStyle = colorStyle;
    ctx.moveTo(xAxes, yAxes);
    ctx.lineTo(xAxesToMove, yAxes);
    ctx.lineWidth = 20;
    ctx.stroke();
    ctx.closePath();
  }

  render() {
    const { liveSecernId, arrayDataSetsForChart, index } = this.props;
    return (
      <div key={index}>
        <canvas style={{ width: '100%' }} ref={(ref) => { this.myCanvas = ref; }} width="400" height="30" />
      </div>
    );
  }
}

export default LiveProgressDetailChart;

